var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("circle", {
        attrs: {
          cx: "12",
          cy: "12",
          r: "11.45",
          stroke: _vm.color,
          "stroke-width": "1.1",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M8 7.84227C8 7.46274 8.40624 7.22158 8.73943 7.40332L16.3619 11.5611C16.7094 11.7506 16.7094 12.2494 16.3619 12.4389L8.73942 16.5967C8.40624 16.7784 8 16.5373 8 16.1577V7.84227Z",
          fill: _vm.color
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }